import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { noop } from "lodash-es";
import React from "react";
import { useSnackbar } from "notistack";
const defaultModalProps = {};
function ModalOpenButtonInternal({ children, Modal, modalProps = defaultModalProps, onOpenCallback, onCloseCallback, disabled, ...props }, ref) {
    const { enqueueSnackbar } = useSnackbar();
    const [isOpen, setIsOpen] = React.useState(false);
    const buttonWithOpen = React.cloneElement(children, {
        onClick: (disabled ?? children.props.disabled)
            ? noop
            : async (e) => {
                await children.props.onClick?.(e);
                setIsOpen(true);
                onOpenCallback?.(e);
            },
        disabled: disabled ?? children.props.disabled,
        ...props,
        ref,
    });
    const buttonWithLoadingIndicator = React.cloneElement(children, {
        ...props,
        isLoading: true,
    });
    return (_jsx(ErrorBoundary, { handleClose: () => {
            setIsOpen(false);
            onCloseCallback?.();
        }, showError: message => enqueueSnackbar(message, { variant: "error" }), children: _jsxs(React.Suspense, { fallback: buttonWithLoadingIndicator, children: [buttonWithOpen, isOpen && (
                // @ts-ignore
                _jsx(Modal, { ...modalProps, handleClose: () => {
                        setIsOpen(false);
                        onCloseCallback?.();
                    } }))] }) }));
}
export const ModalOpenButton = React.memo(React.forwardRef(ModalOpenButtonInternal));
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        // this.state = { hasError: false };
    }
    // static getDerivedStateFromError(error: unknown) {
    //   // Update state so the next render will show the fallback UI.
    //   return { hasError: true };
    // }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        if (error instanceof Error) {
            this.props.showError(error.message);
        }
        else if (error instanceof Object &&
            "__typename" in error &&
            typeof error.__typename === "string") {
            this.props.showError(error.__typename);
        }
        else {
            this.props.showError("Error occurred");
        }
        this.props.handleClose();
    }
    render() {
        // if (this.state.hasError) {
        //   // You can render any custom fallback UI
        //   return (
        //     <Modal
        //       actionButtons={[
        //         {
        //           label: "Close",
        //           handleClick: () => {
        //             this.setState({ hasError: false });
        //             this.props.handleClose();
        //           },
        //         },
        //       ]}
        //     >
        //       Something went wrong
        //     </Modal>
        //   );
        // }
        return this.props.children;
    }
}
//# sourceMappingURL=ModalOpenButton.js.map